import { ref, readonly } from 'vue';
import { get, ENDPOINTS } from '@/api/mainApi';
import store from '@/store';
import { AdminFeeResponse } from '@/interfaces/economy/adminFeeResponse';

export interface AdminFeeParams {
  deliveryMethodId?: number | null;
  paymentMethodId: number;
  intermediaryId?: number | null;
  currency: string;
}

export function useAdminFee() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const calculateAdminFee = async (
    donationCauseId: number,
    donationTypeId: number,
    params: AdminFeeParams
  ): Promise<AdminFeeResponse> => {
    loading.value = true;
    error.value = null;

    try {
      const result = await get(
        `${ENDPOINTS.DONATION_CAUSES}/${donationCauseId}/${ENDPOINTS.DONATION_TYPES}/${donationTypeId}/${ENDPOINTS.ADMIN_FEE}`,
        params
      );
      return result;
    } catch (err) {
      error.value = 'Failed to calculate admin fee';
      window.log?.debug?.('calculateAdminFee failed:', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    calculateAdminFee,
  };
}
